
    import { Vue, Component, Prop } from "vue-property-decorator";
    import EmploymentDetails from "./EmploymentDetails.vue";
    import SelfSchedulingDefault from "./SelfSchedulingDefault.vue";
    import SchedulingPref from "./SchedulingPref.vue";
    import SMSPref from "./SMSPref.vue";
    import NotificationMgmt from "./NotificationMgmt.vue";
    import PayrollDetails from "./PayrollDetails.vue";
    import SharedPanel from "./SharedPanel.vue"
    import { namespace } from "vuex-class";
    const profile = namespace("profile");
    import SaveMsgPopUp from "@/views/shared/SaveMsgPopUp.vue";

    import { mapGetters } from "vuex";
    @Component({
        components: { EmploymentDetails, SchedulingPref, SMSPref, NotificationMgmt, PayrollDetails, SelfSchedulingDefault, SharedPanel, SaveMsgPopUp },
        computed: {
            ...mapGetters(["oidcUser"]),
        },
    })
    export default class Profile extends Vue {
        oidcUser!: any;
        @profile.State
        public profileData!: any;

        userName: string = "";
        nameInitials: string = "";

        selectedTab = "EmpDtls";
        headerCaption = "My Employment Details";
        pagingNumber = "Page 1 of 4";
        isSelfScheduleAllowed: boolean = false;
        isSharedPanelOpen: boolean = false;
        calenderSelectedDates: any = {};
        currentShifts!: any;
        isNotificationMessageVisible: boolean = false;
        msgValue: string = '';
        classFlag: string = '';
        counter: any = 0;
        ssdCounter: any = 0;

        async mounted() {
            if (this.profileData) {
                this.userName = this.profileData.first + " " + this.profileData.last;
                    
                if (this.profileData.first != undefined && this.profileData.last != undefined) {
                    this.nameInitials = this.profileData.first.charAt(0).toUpperCase() + this.profileData.last.charAt(0).toUpperCase();
                }

                this.isSelfScheduleAllowed = this.profileData.selfSchedule;
                if (this.isSelfScheduleAllowed){
                    this.pagingNumber = "Page 1 of 5";
                }

                var isSelfScheduleDefaultRedirect = (localStorage.getItem("isSelfScheduleDefaultRedirect") == null ? false : localStorage.getItem("isSelfScheduleDefaultRedirect")=='true');
                
                if(isSelfScheduleDefaultRedirect){
                    this.clickTab("SelfSchPrefDefault");
                    localStorage.removeItem("isSelfScheduleDefaultRedirect");
                }
            }
        }

        clickTab(flag: string) {
            if (this.isSelfScheduleAllowed) {
                if (flag == "EmpDtls") {
                    this.selectedTab = "EmpDtls";
                    this.headerCaption = "My Employment Details";
                    this.pagingNumber = "Page 1 of 5";
                } else if (flag == "SelfSchPrefDefault") {
                    this.selectedTab = "SelfSchPrefDefault";
                    this.headerCaption = "Self-Scheduling Defaults";
                    this.pagingNumber = "Page 2 of 5";
                } else if (flag == "SchPref") {
                    this.selectedTab = "SchPref";
                    this.headerCaption = "Scheduling Preferences";
                    this.pagingNumber = "Page 3 of 5";
                } else if (flag == "SMSPref") {
                    this.selectedTab = "SMSPref";
                    this.headerCaption = "SMS Preferences";
                    this.pagingNumber = "Page 4 of 5";
                } else if (flag == "PayrollDtls") {
                    this.selectedTab = "PayrollDtls";
                    this.headerCaption = "Employee Payroll Details";
                    this.pagingNumber = "Page 5 of 5";
                }

                if (this.selectedTab == "SelfSchPrefDefault" && this.ssdCounter != 0) {
                    this.ssdCounter = 0;
                }
            }
            else {
                if (flag == "EmpDtls") {
                    this.selectedTab = "EmpDtls";
                    this.headerCaption = "My Employment Details";
                    this.pagingNumber = "Page 1 of 4";
                } else if (flag == "SchPref") {
                    this.selectedTab = "SchPref";
                    this.headerCaption = "Scheduling Preferences";
                    this.pagingNumber = "Page 2 of 4";
                } else if (flag == "SMSPref") {
                    this.selectedTab = "SMSPref";
                    this.headerCaption = "SMS Preferences";
                    this.pagingNumber = "Page 3 of 4";
                } else if (flag == "PayrollDtls") {
                    this.selectedTab = "PayrollDtls";
                    this.headerCaption = "Employee Payroll Details";
                    this.pagingNumber = "Page 4 of 4";
                }
            }

            //else if (flag == "NtfMgmt") {
            //    this.selectedTab = "NtfMgmt";
            //    this.headerCaption = "Notification Management";
            //    this.pagingNumber = "Page 4 of 4";
            //}
            //---Need to add code for Notification Management
        }

        isSelected(selectedTabVal: string) {
            return this.selectedTab === selectedTabVal;
        }

        callPreviousPage() {
            if (this.isSelfScheduleAllowed) {
                if (this.selectedTab === "SelfSchPrefDefault") {
                    this.clickTab("EmpDtls");
                } else if (this.selectedTab === "SchPref") {
                    this.clickTab("SelfSchPrefDefault");
                } else if (this.selectedTab === "SMSPref") {
                    this.clickTab("SchPref");
                } else if (this.selectedTab === "PayrollDtls") {
                    this.clickTab("SMSPref");
                }
            }
            else {
                if (this.selectedTab === "SchPref") {
                    this.clickTab("EmpDtls");
                } else if (this.selectedTab === "SMSPref") {
                    this.clickTab("SchPref");
                } else if (this.selectedTab === "PayrollDtls") {
                    this.clickTab("SMSPref");
                }
            }

        }

        callNextPage() {
            if (this.isSelfScheduleAllowed) {
                if (this.selectedTab === "EmpDtls") {
                    this.clickTab("SelfSchPrefDefault");
                } else if (this.selectedTab === "SelfSchPrefDefault") {
                    this.clickTab("SchPref");
                } else if (this.selectedTab === "SchPref") {
                    this.clickTab("SMSPref");
                } else if (this.selectedTab === "SMSPref") {
                    this.clickTab("PayrollDtls");
                }
            }
            else {
                if (this.selectedTab === "EmpDtls") {
                    this.clickTab("SchPref");
                } else if (this.selectedTab === "SchPref") {
                    this.clickTab("SMSPref");
                } else if (this.selectedTab === "SMSPref") {
                    this.clickTab("PayrollDtls");
                }
            }

        }

        showSidePanel(options) {
            this.isSharedPanelOpen = options.sharedToggle;
            this.calenderSelectedDates = options.calSelectedDates;
            this.currentShifts = options.currentShift;
            this.counter = this.counter + 1;
        }

        closeModal() {
            this.isSharedPanelOpen = false;
            if (this.ssdCounter >= 0) {
                this.ssdCounter = -1;
            }
            else {
                this.ssdCounter = this.ssdCounter - 1;
            }
        }

        showSMPModal(successFlag: boolean = true, msgValue: string = '') {
            window.scrollTo(0, 0);
            if (msgValue != '') {
                this.msgValue = successFlag ? msgValue : "Failed to save your changes";
            }
            else {
                this.msgValue = successFlag ? "Your changes have been saved." : "Failed to save your changes";
            }
            this.classFlag = successFlag ? "success" : "error";
            this.isNotificationMessageVisible = true;
            
            if (this.ssdCounter <= 0) {
                this.ssdCounter = 1;
            }
            else {
                this.ssdCounter = this.ssdCounter + 1;
            }
            this.isSharedPanelOpen = false;
        }

        closeSMPModal() {
            this.isNotificationMessageVisible = false;
        }

        showNotificationModal(options) {
            if (options.msgValue != '') {
                this.msgValue = options.msgValue;
            }
            else {
                this.msgValue = options.successFlag ? "Your changes have been saved." : "Failed to save your changes";
            }
            this.classFlag = options.successFlag ? "success" : "error";
            this.isNotificationMessageVisible = true;
        }
    }
